import React from 'react'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import Settings from '../../Settings'

export const Container = styled.div`
  position: absolute;
  top: 29.54%;
  left: 19.43%;
  right: 19.43%;
  width: 61.14%;
  height: 40.92%;
`
//442
export const Button = styled(Link)`
  height: 46.38%;
  width: 100%;
  position: relative;
  cursor: pointer;
  display: block;

  :not(:last-child) {
    margin-bottom: 3%;
  }

  :last-child {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }

  &:hover {
    &,
    a {
      color: ${Settings.themeColor};
    }

    .icon {
      &.normal {
        display: none;
      }

      &.hover {
        display: block;
      }
    }
  }
`

export const InfoButton = styled.div`
  height: 33.33333%;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.4);
  position: relative;
  cursor: pointer;

  :last-child {
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }

  &:hover {
    &,
    a {
      color: ${Settings.themeColor};
    }

    .icon {
      &.normal {
        display: none;
      }

      &.hover {
        display: block;
      }
    }
  }
`

export const Icon = styled.div`
  width: 12%;
  left: 10%;
  height: 100%;
  float: left;
  z-index: 2;
  position: absolute;
  display: table;

  > div {
    display: table-cell;
    vertical-align: middle;
  }

  .icon {
    &.normal {
      display: block;
    }

    &.hover {
      display: none;
    }
  }
`

export const Text = styled.div`
  width: 62%;
  left: 28%;
  height: 100%;
  position: absolute;
  display: table;

  > div {
    display: table-cell;
    vertical-align: middle;

    > p {
      font-size: 3vw;
      margin: 0;

      em {
        color: ${Settings.themeColor};
      }
    }
  }

  a {
    text-decoration: none;
  }
`

export const ButtonText = ({children}) => (
  <Text>
    <div>
      <p>{children}</p>
    </div>
  </Text>
)

export const ButtonTextSmall = ({children}) => (
  <Text>
    <div>
      <p style={{fontSize: '2vw'}}>{children}</p>
    </div>
  </Text>
)

export const ButtonIcon = ({normal, hover}) => (
  <Icon>
    <div>
      <img src={normal} alt="" className="icon normal" />
      <img src={hover} alt="" className="icon hover" />
    </div>
  </Icon>
)
